
// SVG Icon: enable
export default { id: "terriajs-enable" };
export const id = "terriajs-enable";
export const name = "enable";
